// trusted-urls.ts
export const TRUSTED_IFRAME_URL =
  'https://dev-moodle.insightstobehavior.net/local/course_manager_learners/admin/participants.php';
export const TRUST_LOGOUT_URL =
  'https://dev-moodle.insightstobehavior.net/login/logout.php';
